var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allTimers)?_c('div',{staticClass:"sticky-timer"},[_c('div',{staticClass:"inner"},[(_vm.runningTimer)?_c('timer',{staticClass:"running-timer",attrs:{"task":_vm.runningTimer.task,"show-details":""}}):(_vm.firstPausedTimer)?_c('timer',{staticClass:"paused-timer",attrs:{"task":_vm.firstPausedTimer.task,"show-details":""}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }